import React from 'react'
import { array, bool, func, shape, string, number } from 'prop-types'
import AnnotationDroplist from './AnnotationDroplist'
import AnnotationColorHelper from './AnnotationColorHelper'

function triDotHeader(annotationTypes, onSelect) {
  return <AnnotationDroplist
    annotationTypes={annotationTypes}
    onSelect={onSelect}
    dropLocation="dropdown-content-right"
  />
}

const AnnotationHeader = ({ annotation, roleType, annotationTypes, onSelect }) => {
  const { resolved } = annotation
  const rightAction = (roleType == 'area_director' || roleType == 'store_designer') && !annotation.id ? triDotHeader(annotationTypes, onSelect) : null;
  const type = annotation.type_label || annotation.simple_type || 'comment';
  const headerTitle = resolved ? 'Resolved' : type.charAt(0).toUpperCase() + type.slice(1);

  return (
    <div className={`${AnnotationColorHelper(annotation)} px-0 py-1 d-flex flex-row`}>
      <div className="d-flex flex-column col-10">
        <h4 className="text-white mb-0 py-1">{headerTitle}</h4>
      </div>
      {rightAction}
    </div>
  )
}

AnnotationHeader.propTypes = {
  annotation: shape({
    id: number,
    type_label: string,
    simple_type: string,
    resolved: bool,
  }).isRequired,

  roleType: string.isRequired,

  annotationTypes: array.isRequired,

  onSelect: func.isRequired,
}

export default AnnotationHeader
